import { useEffect } from "react"
import mount from "core/mount"
import { toast } from "@kit/design/toast"

export function Flash({ message, level }) {
  // Flash messages are error, alert, notice or success;
  // Mapping to the types available with toast
  const type = {
    error: "error",
    alert: "error",
    notice: "info",
    success: "success"
  }

  useEffect(() => {
    toast({
      type: type[level],
      text: message,
      closable: true,
      duration: 10000
    })
  }, [])

  return null
}

mount({ Flash })
